<!--电能消耗-->
<template>
	<div class="usePowerDifferenceBody">
		<!--日期弹窗-->
		<datePicker ref="endPicker" :initDate='nowSelectDate' :timeInterval="nowTimeInterval" @selectDate="cacheStore.commit('setNowSelectDate',$event),$refs.endPicker.hide()" @selectMonth="cacheStore.commit('setNowSelectDate',$event),$refs.endPicker.hide()" @selectYear="cacheStore.commit('setNowSelectDate',$event),$refs.endPicker.hide()" :type="datePickerType" @selectTimeInterval="selectTimeInterval($event)" :endCanSelect="endCanSelect"></datePicker>
		<!--<elRadioTree slot="tree" :dataList='virtualDeviceList' @checkItem="nowVirtualDevice = $event"></elRadioTree>-->
		<elCheckBoxTree slot="tree" :dataList='virtualDeviceList' @checkItem="nowProcess"></elCheckBoxTree>
		<div class="pageBody" slot="body">
			<div class="buttonLine">
				<timeTypeSelection @selectTimetype="nowTimetype = $event" :userDefined="true"></timeTypeSelection>
				<div class="dataType">
					<label style="padding: 0 10px;">能源类型</label>
					<el-radio-group v-model="targetApptype">
						<el-radio :label="237">水</el-radio>
						<el-radio :label="36">电</el-radio>
<!--						<el-radio :label="351">气</el-radio>-->
<!--						<el-radio :label="352">汽</el-radio>-->
						<el-radio :label="361">气</el-radio>
						<el-radio :label="362">汽</el-radio>
					</el-radio-group>
				</div>
				<iconButton icoName="wedoButton/date.png" :buttonText="getDateText(nowSelectDate, nowTimeInterval)" @buttonClick="$refs.endPicker.show()"></iconButton>
				<iconButton icoName="wedoButton/search.png" buttonText="查询" @buttonClick="search"></iconButton>
				<iconButton icoName="wedoButton/download.png" buttonText="导出" @buttonClick="exportExcel"></iconButton>
				<!--<iconButton icoName="wedoButton/download.png" buttonText="全站导出" @buttonClick="exportAllExcel"></iconButton>-->
			</div>
			<!--图表-->
			<vchart style="height: calc(60% - 1rem);" ref='vchart'></vchart>
			<!--表格显示数据-->
			<infoList ref="infoList" style="height: 40%;" :columns='columns' :dataList="nowPage" :pageLen='pageLen' :totalSize="showDataList.length" @selectPage="nowIndex = $event" :dataType='1' :fillAll="['week','quarter','year'].includes(nowTimetype) "></infoList>
		</div>
	</div>
</template>

<script type="text/javascript">
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import timeTypeSelection from '@/components/module/selection/timeTypeSelection.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
	import variableApi from "../../components/api/variableApi";
	export default {
		components: {
			treeBody,
			datePicker,
			iconButton,
			multipleSelection,
			vchart,
			infoList,
			timeTypeSelection,
			elRadioTree,
			elCheckBoxTree
		},
		props: [],
		data() {
			return {
				nowVirtualDevice: undefined,
				nowTimetype: 'day',
				options: {},
				dataObject: {},
				nowIndex: 0,
				pageLen: 5,
				weekList: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
				from2name: {},
				targetApptype: 36,
				endTime: '',
				endCanSelect: new Date(new Date().getTime() + 60 * 60 * 24),
				radio: 36,
				unit: '',
				variableTree: [],
				nowSelectItem:[]
			}
		},
		created() {},
		mounted() {
			debugPage = this
			//初始化图表
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.toolbox['iconStyle'] = {
				'color': 'white',
				'borderColor': 'white',
				'shadowColor': 'white'
			}
			this.options.backgroundColor = '#FFFFFF'
			this.options.tooltip.formatter = (params, ticket, callback) => {
				if(params[0].data == undefined) {
					return ""
				}
				var h = params[0].data[0]
				var label = h + "</br>"
				params.forEach(item => {
					var values;
					if(isnull(item.data[1])) {
						values = "无采集数据";
					} else {
						values = cutDigital(item.data[1]);
					}
					label += item.seriesName + " : " + values + " (kW·h)</br>"
				})
				return label;
			}
			this.options.yAxis = {
				splitLine: {
					show: true
				}
			}
			switch(this.targetApptype) {
				case 36:
					this.options.title.text = "用电量统计"
					break
				case 237:
					this.options.title.text = "用水量统计"
					break
				case 351:
					this.options.title.text = "用气量统计"
					break
				case 352:
					this.options.title.text = "用汽量统计"
					break
			}
			this.$refs.vchart.setData(this.options, true)
		},
		destroyed() {},
		computed: {
			nowTimeInterval() {
				return this.cacheStore.getters.getNowTimeInterval
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			cacheStore() {
				return this.$store.cacheStore
			},
			virtualDeviceList() {
				if(isempty(this.nowUnit)) {
					return []
				}
				return [deviceList(this.$store.deviceStore.getters.getProcessTreeWithTypeNos(this.targetApptype, this.nowUnit.id))]
			},
			datePickerType() {
				switch(this.nowTimetype) {
					case 'day':
					case 'week':
						return 'day'
					case 'month':
					case 'quarter':
						return 'month'
					case 'year':
						return 'year'
					case 'custom':
						return 'custom'
				}
			},
			apptypeGroups() {
				//所有已选中的设备所具有的变量类型组
				var list = []
				var apptypeGroupIds = []
				this.variableTree.forEach(apptypeGroup => {
					if(!apptypeGroupIds.includes(apptypeGroup.id)) {
						apptypeGroupIds.push(apptypeGroup.id)
						list.push(apptypeGroup)
					}
				})
				//排序
				return list.sort((a, b) => {
					return a.serialnum - b.serialnum
				})
			},
			nowSelectDate() {
				return this.cacheStore.getters.getNowSelectDate
			},
			// variableTree() {
			// 	if(isempty(this.nowVirtualDevice)) {
			// 		return []
			// 	}
			// 	var deviceNoList = [];
			// 	//找出所有目录下的虚拟设备
			// 	//var devices = [];
			// 	// if(this.nowVirtualDevice != null) {
			// 	// 	if(isempty(this.nowVirtualDevice[0].children)) {
			// 	// 		//没有父节点
			// 	// 		devices = this.nowVirtualDevice
			// 	// 	}else {
			// 	// 		//有父节点
			// 	// 		devices = this.nowVirtualDevice[0].children
			// 	// 	}
			// 	// 	//获取所有设备号
			// 	// 	for(var i = 0; i<devices.length;i++) {
			// 	// 		deviceNoList.push(devices[i].no)
			// 	// 	}
			// 	// }
			// 	if(this.nowVirtualDevice != null) {
			// 		for(var i = 0;i<this.nowVirtualDevice.length;i++) {
			// 			if(!isempty(this.nowVirtualDevice[i].children)) {
			// 				continue
			// 			}else {
			// 				deviceNoList.push(this.nowVirtualDevice[i].no)
			// 			}
			// 		}
			// 	}
			// 	return this.$store.variableStore.getters.getVariableTree(deviceNoList.join(","))
			// 	//return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice[0].no)
			// },
			columns() {
				var list = [{
					name: '工序',
					weight: 3,
				}]
				switch(this.nowTimetype) {
					case 'day':
						//取出每个整点值
						for(var i = 0; i < 24; i++) {
							var label = (i < 10 ? "0" : '') + (i) + ":00-" + (i + 1 < 10 ? "0" : '') + (i + 1) + ":00"
							list.push({
								name: label //i + ' - ' + (i + 1)
							})
						}
						break
					case 'week':
						for(var i = 0; i < 7; i++) {
							list.push({
								name: this.weekList[i]
							})
						}
						break
					case 'month':
						let lasDay = new Date(this.nowSelectDate.format("yyyy"), this.nowSelectDate.format("MM"), 0).getDate()
						for(var i = 1; i <= lasDay; i++) {
							list.push({
								name: i + "日"
							})
						}
						break
					case 'quarter':
						for(var i = 0; i < 3; i++) {
							list.push({
								name: this.getQuarterList(this.nowSelectDate)[i]
							})
						}
						break
					case 'year':
						for(var i = 1; i <= 12; i++) {
							list.push({
								name: i + "月"
							})
						}
						break
					case 'custom':
						var time = this.nowTimeInterval.endDate.getTime() - this.nowTimeInterval.startDate.getTime()
						var dayNum = Math.floor((time) / (24 * 60 * 60 * 1000)) + 1
						var value = []
						if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
							value = undefined
						}
						if(this.nowTimeInterval.endDate.getMonth() != this.nowTimeInterval.startDate.getMonth()) {
							var lastmonthNum = dayNum - this.nowTimeInterval.endDate.getDate()
							for(var i = 0; i < lastmonthNum; i++) {
								list.push({
									name: this.nowTimeInterval.startDate.getMonth() + 1 + '月' + (this.nowTimeInterval.startDate.getDate() + i) + '日'
								})
							}
							for(var j = 0; j < this.nowTimeInterval.endDate.getDate(); j++) {
								list.push({
									name: this.nowTimeInterval.endDate.getMonth() + 1 + '月' + (j + 1) + '日'
								})
							}
						} else {
							if(this.nowTimeInterval.startDate.getDate() == this.nowTimeInterval.endDate.getDate()) {
								list.push({
									name: this.nowTimeInterval.endDate.getMonth() + 1 + '月' + (this.nowTimeInterval.endDate.getDate()) + '日'
								})
							} else {
								for(var i2 = 0; i2 < dayNum; i2++) { //l.length
									list.push({
										name: this.nowTimeInterval.startDate.getMonth() + 1 + '月' + (this.nowTimeInterval.startDate.getDate() + i2) + '日'
									})
								}
							}

						}
						break
				}
				return list
			},
			// nowVariableNames() {
			// 	//当前应该显示的变量
			// 	var variableList = []
			// 	for(var i = 0, len = this.variableTree.length; i < len; i++) {
			// 		this.variableTree[i].next.forEach(v => {
			// 			if(v.typeNo == this.targetApptype) {
			// 				this.unit = this.variableTree[i].unit
			// 				this.from2name[v.fromName] = v.name
			// 				variableList.push(v.fromName)
			// 			}
			// 		})
			// 	}
			// 	return variableList
			// },

			// nowVariableNamesS() {
			// 	//当前应该显示的变量
			// 	var variableList = []
			// 	this.nowDevice.forEach(item => {
			// 		this.nowVirtualDevice = item
			// 		for(var i = 0, len = this.variableTree.length; i < len; i++) {
			// 			this.variableTree[i].next.forEach(v => {
			// 				if(v.typeNo == this.targetApptype) {
			// 					this.from2name[v.fromName] = v.name
			// 					variableList.push(v.fromName)
			// 				}
			// 			})
			// 		}
			// 	})
			//
			// 	return variableList
			// },
			showDataList() {
				//用于渲染的合并后的数组
				if(isempty(this.dataObject)) {
					return []
				}
				//取出数据中的有效数据组织为数组
				var list = []
				var keys = Object.keys(this.dataObject)
				for(var i = 0, len = keys.length; i < len; i++) {
					var key = keys[i]
					var dataList = this.dataObject[key].map(i => {
						if(isNaN(parseFloat((i))) || isnull(parseFloat((i)))) {
							return undefined
						} else {
							return i
						}
					})
					// if(this.nowTimetype == "month") {
					// 	let lasDay = new Date(this.nowSelectDate.format("yyyy"), this.nowSelectDate.format("MM"), 0).getDate()
					// 	if(lasDay == 30) {
					// 		dataList.shift()
					// 	}
					// }
					//var vList = [key.subByFirstChar('.')]
					var vList = [key]
					vList.addAll(dataList)
					list.push(vList)
				}
				return list.sort()
			},
			chartDataList() {
				//图表使用的数据
				var list = []
				for(var i = 0, len = this.showDataList.length; i < len; i++) {
					var l = this.showDataList[i]
					//var l2 = [this.nowVariableNames[i]] //变量名称
					var l2 = [this.showDataList[i][0]]
					switch(this.nowTimetype) {
						case 'day':
							//取出每个整点值
							for(var i2 = 1, len2 = 25; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								var label = (i2 - 1 < 10 ? "0" : '') + (i2 - 1) + ":00-" + (i2 < 10 ? "0" : '') + i2 + ":00"
								l2.push([label, value])
							}
							break
						case 'week':
							for(var i2 = 1, len2 = 8; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([this.weekList[i2 - 1], value])
							}
							break
						case 'month':
							let lasDay = new Date(this.nowSelectDate.format("yyyy"), this.nowSelectDate.format("MM"), 0).getDate() + 1
							//判断月份是否有31
							for(var i2 = 1, len2 = lasDay; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([(i2) + '日', value])
							}
							break
						case 'quarter':
							for(var i2 = 1, len2 = 4; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([this.getQuarterList(this.nowSelectDate)[i2 - 1], value])
							}
							break
						case 'year':
							for(var i2 = 1, len2 = 13; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([(i2) + '月', value])
							}
							break
						case 'custom':
							var time = this.nowTimeInterval.endDate.getTime() - this.nowTimeInterval.startDate.getTime()
							var dayNum = Math.floor((time) / (24 * 60 * 60 * 1000)) + 1
							var value = []
							if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
								value = undefined
							}
							if(this.nowTimeInterval.endDate.getMonth() != this.nowTimeInterval.startDate.getMonth()) {
								var lastmonthNum = dayNum - this.nowTimeInterval.endDate.getDate()
								for(var i = 0; i < lastmonthNum; i++) {
									l2.push([this.nowTimeInterval.startDate.getMonth() + 1 + '月' + (this.nowTimeInterval.startDate.getDate() + i) + '日', l[i + 1]])
								}
								for(var j = 0; j < this.nowTimeInterval.endDate.getDate(); j++) {
									l2.push([this.nowTimeInterval.endDate.getMonth() + 1 + '月' + (j + 1) + '日', l[j + lastmonthNum + 1]])
								}
							} else {
								if(this.nowTimeInterval.startDate.getDate() == this.nowTimeInterval.endDate.getDate()) {
									l2.push([this.nowTimeInterval.endDate.getMonth() + 1 + '月' + (this.nowTimeInterval.endDate.getDate()) + '日', l[1]])
								} else {
									for(var i2 = 0; i2 < dayNum; i2++) { //l.length
										l2.push([this.nowTimeInterval.startDate.getMonth() + 1 + '月' + (this.nowTimeInterval.startDate.getDate() + i2) + '日', l[i2 + 1]])
									}
								}
							}
							l2.push([this.nowTimeInterval.startDate.formatByTime(), l[1]])
							break
					}
					list.push(l2)
				}
				return list
			},
			nowPage() {
				//按照页码来返回当前应该显示的列表
				return this.showDataList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
			},
			getDateText() {
				return(date, timeInterval) => {
					switch(this.nowTimetype) {
						case 'day':
							return date.formatByDate('-')
						case 'week':
							return date.formatByDate('-')
						case 'month':
							return date.formatByMonth('-')
						case 'quarter':
							return date.formatByMonth('-')
						case 'year':
							return date.getFullYear() + ''
						case 'custom':
							return timeInterval.startDate.formatByDate('/') + "—" + timeInterval.endDate.formatByDate('/')
					}
				}
			},
		},
		watch: {
			nowVariableNames(nv, ov) {
				//this.search()
			},
			chartDataList(nv, ov) {
				//重新渲染
				this.reloadChart(nv)
			},
			nowTimetype(nv, ov) {
				//this.search()
			},
			nowSelectDate(nv, ov) {
				//this.search()
			},
			nowTimeInterval(nv, ov) {
				//this.search()
			},
			targetApptype(nv, ov) {
				//切换能源类型刷新页面
				this.dataObject = {}
				switch(this.targetApptype) {
					case 36:
						this.options.title.text = "用电量统计"
						break
					case 237:
						this.options.title.text = "用水量统计"
						break
					case 351:
						this.options.title.text = "用气量统计"
						break
					case 352:
						this.options.title.text = "用汽量统计"
						break
				}
				this.$refs.vchart.setData(this.options, true)
			}
		},
		methods: {
			nowProcess(data) {
				this.nowSelectItem = data;
			},
			selectTimeInterval(ev) {
				this.cacheStore.commit('setNowTimeInterval', ev)
				this.$refs.endPicker.hide()
			},
			search() {
				if (isempty(this.nowSelectItem)) {
					this.$message({
						message: '请先勾选',
						type: 'error'
					});
					return;
				}
				let newArr = [];
				//过滤勾选内容
				this.nowSelectItem.forEach(item => {
					if (isempty(newArr)) {
						newArr.push(item);
					} else {
						let flag = false;
						for (let i = 0; i < this.nowSelectItem.length; i++) {
							//flag = true;
							//如果是设备就直接加入
							// if(item.type == "virtualDevice" && item.pcode == newArr[i].code) {
							//     flag = false;
							// }
							//如果已经勾选了父类那就跳过
							if (item.pcode == this.nowSelectItem[i].code) {
								flag = true;
								break;
							}
						}
						if (!flag) {
							newArr.push(item);
						}
						//newArr.push(item);
					}
				})
				this.processIds = [];
				this.deviceNos = [];
				if (!isempty(newArr)) {
					newArr.forEach(item => {
						if (item.type == "virtualDevice") {
							this.deviceNos.push(item.deviceNo);
						} else {
							this.processIds.push(item.id);
						}
					})
				}
				this.dataObject = {}
				this.$api.teamAssessmentApi.getCheckedProcessEnergy(this.nowTimetype, this.nowSelectDate.getTime(), '', this.processIds.join(','), this.deviceNos.join(','), this.targetApptype,res => {
					console.log(res)
					this.dataObject = res
				})
			},
			// search() {
			// 	//先查询设备信息  再查数据
			// 	if(isempty(this.nowVirtualDevice)) {
			// 		return;
			// 	}
			// 	var deviceNoList = []
			// 	for(var i=0;i<this.nowVirtualDevice.length;i++) {
			// 		if(!isempty(this.nowVirtualDevice[i].children)) {
			// 			continue
			// 		}else {
			// 			deviceNoList.push(this.nowVirtualDevice[i].no)
			// 		}
			// 	}
			// 	this.$api.variableApi.getVariableTree ( deviceNoList.join(","),respon => {
			// 		this.variableTree = respon
			// 		if(isempty(this.nowVariableNames)) {
			// 		return
			// 	}
			// 	this.dataObject = {}
			// 	if(this.nowTimetype == 'custom') {
			// 		if(this.nowTimeInterval.endDate.getTime() - this.nowTimeInterval.startDate.getTime() > 60 * 60 * 24 * 30 * 1000) {
			// 			this.$dialogMethod.showMessage("时间跨度不能大于一个月!")
			// 			return
			// 		}
			// 		this.$api.historyApi.getHistoryDifferenceRanking(this.nowVariableNames.join(','), this.nowTimetype, this.nowTimeInterval.startDate.getTime(), this.nowTimeInterval.endDate.getTime(),
			// 			respon => {
			// 				this.dataObject = respon
			// 			})
			// 	} else {
			// 		this.$api.historyApi.getHistoryDifferenceRanking(this.nowVariableNames.join(','), this.nowTimetype, this.nowSelectDate
			// 			.getTime(), '',
			// 			respon => {
			// 				this.dataObject = respon
			// 			})
			// 	}
			// 	})
			// },
			reloadChart(list) {
				var selected = {}
				var legend = []
				var seriesList = []
				for(var i = 0, len = list.length; i < len; i++) {
					let item = list[i]
					var name = list[i].shift()
					seriesList.push({
						name: name,
						type: 'line',
						smooth: true,
						symbol: 'emptyCircle',
						sampling: 'average',
						data: item
					})
					selected[name] = i < 12 ? true : false
					legend.push({
						name: name,
						icon: 'roundRect'
					})
				}
				this.options.series = seriesList
				this.options.legend.data = legend
				this.options.legend.selected = selected
				this.options.tooltip.formatter = (params, ticket, callback) => {
					if(params[0].data == undefined) {
						return ""
					}
					var h = params[0].data[0]
					var label = h + "</br>"
					params.forEach(item => {
						var values;
						if(isnull(item.data[1])) {
							values = "无采集数据";
						} else {
							values = cutDigital(item.data[1]);
						}
						label += item.seriesName + " : " + values + " (" + this.unit + ")</br>"
					})
					return label;
				}
				switch(this.targetApptype) {
					case 36:
						//this.options.title.text = this.nowVirtualDevice.name + "-用电量"
						this.options.title.text = "用电量"
						break
					case 237:
						this.options.title.text = this.nowVirtualDevice.name + "-用水量"
						break
					case 291:
						this.options.title.text = this.nowVirtualDevice.name + "-用气量"
						break
				}
				this.$refs.vchart.setData(this.options, true)
			},
			getQuarterList(date) {
				switch(date.getMonth() / 3 | 0) {
					case 0:
						return ['一月', '二月', '三月']
					case 1:
						return ['四月', '五月', '六月']
					case 2:
						return ['七月', '八月', '九月']
					case 3:
						return ['十月', '十一月', '十二月']
				}
			},
			exportExcel() {
				this.nowDevice = [this.nowVirtualDevice]
				let list = this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(this.targetApptype, this.nowUnit.id)
				var title = '电能消耗'
				switch(this.nowTimetype) {
					case "custom":
						title = this.nowTimeInterval.startDate.format("yyyy年MM月dd日") + "至" + this.nowTimeInterval.endDate.format("yyyy年MM月dd日") + "电能消耗"
						break;
					case "day":
						title = this.nowSelectDate.format("yyyy年MM月dd日") + "电能消耗"
						break;
					case "week":
						let getDate = getMonthWeek(this.nowSelectDate.format("yyyy"), this.nowSelectDate.format("MM"), this.nowSelectDate.format("dd"));
						title = getDate.getYear + "年" + getDate.getMonth + "月第" + getDate.getWeek + "周" + "电能消耗"
						break;
					case "month":
						title = this.nowSelectDate.format("yyyy年MM月") + "电能消耗"
						break;
					case "quarter":
						title = "第" + this.nowSelectDate.format("q") + "季电能消耗"
						break;
					case "year":
						title = this.nowSelectDate.format("yyyy") + "年电能消耗"
						break;
					default:
						title = "电能消耗"
				}

				if(this.nowTimetype != 'custom') {
					this.$api.reportApi.exportHistoryDifferenceRanking(title, this.nowVariableNamesS.join(','), this.nowSelectDate.getTime(), this.nowTimetype,
						respon => {
							saveAs(DWSystemSetting.downloadUrl + '/' + respon, title + ".xls")
						})
				} else {
					//时间段的导出
					this.$api.reportApi.exportHistoryDifferenceRankingCustom(title, this.nowVariableNamesS.join(','), this.nowTimeInterval.startDate.getTime(), this.nowTimeInterval.endDate.getTime(), this.nowTimetype,
						respon => {
							saveAs(DWSystemSetting.downloadUrl + '/' + respon, title + ".xls")
						})
				}
				
			},
			exportAllExcel() {
				this.$dialogMethod.showLoading("正在生成报告。。。")
				if(this.nowTimetype != 'custom') {
					this.$api.reportApi.exportAllPowerDifferenceRanking(this.nowSelectDate.getTime(), respon => {
						if(!respon.includes('%2F')) {
							this.$dialogMethod.showMessage(respon)
							return
						}
						saveAs(DWSystemSetting.downloadUrl + '/' + respon, respon.substring(respon.lastIndexOf('%2F') + 3))
						this.$dialogMethod.closeLoading()
					})
				} else {
					this.$api.reportApi.exportAllPowerDifferenceRankingCustom(this.nowTimeInterval.startDate.getTime(), this.nowTimeInterval.endDate.getTime(), this.nowTimetype, respon => {
						if(!respon.includes('%2F')) {
							this.$dialogMethod.showMessage(respon)
							return
						}
						saveAs(DWSystemSetting.downloadUrl + '/' + respon, respon.substring(respon.lastIndexOf('%2F') + 3))
						this.$dialogMethod.closeLoading()
					})
				}
			}
		}
	}
</script>

<style scoped>
	.pageBody {
		width: 81%;
		height: 100%;
		padding-bottom: 60px;
		padding-top: 75px;
	}
	
	.timeTips {
		font-size: .14rem;
		margin-left: .1rem;
	}
	
	.usePowerDifferenceBody {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
	}
	
	.dataType {
		border: solid #d4d4d4 .01rem;
		border-radius: 5px;
		height: 28px;
		display: flex;
		align-items: center;
	}
</style>
<style>
	.dataType .el-radio {
		margin-right: 10px;
	}
</style>